import React from 'react'

import { TButton } from './types'

export const SelectButton = ({
  children,
  isActive,
  direction,
  className,
  ...props
}: TButton & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'>) => {
  className = `${className || ''} ${direction}`
  if (isActive) {
    className += ' selected'
  }
  return (
    <button className={className} type="button" {...props}>
      {children}
    </button>
  )
}
